import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { oktaAuth } from '../../auth/okta'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: white;
  color: black;
`

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #d70036;
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 1rem;

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`

const ErrorBox = styled.div`
  color: #d70036;
  max-width: 480px;
  text-align: center;
  line-height: 1.5;
`

const LoginCallback: React.FC = () => {
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    oktaAuth
      .handleLoginRedirect()
      .then(() => {
        navigate('/', { replace: true })
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : 'Sign in could not be completed.')
      })
  }, [navigate])

  if (error) {
    return (
      <Container>
        <ErrorBox>
          <h2>Sign in failed</h2>
          <p>{error}</p>
          <p>
            <button onClick={() => navigate('/', { replace: true })}>Back to sign in</button>
          </p>
        </ErrorBox>
      </Container>
    )
  }

  return (
    <Container>
      <Spinner />
      <div>Signing you in…</div>
    </Container>
  )
}

export default LoginCallback
